<template>
    <div>
<!--BOTON VER  PERFIL-->
        
        <v-layout v-if="identity!=null" v-show="dialog">
            <v-dialog v-model="dialog" style="z-index:1000;overflow:hidden; max-height:300px; overflow-y:auto" max-width="300" class="scrollmenucompany"> 
                    <v-flex id="user">
                        <img id="avatar" :src="userstorage.photo">
                    
                    <i class="fa fa-gear"></i>
                    
                    <div id="main">
                            <h3>{{userstorage.username}}</h3>
                            <p>{{userstorage.fullname}}</p>
                    </div>
                    
                    <div id="information">
                        <p v-if="identity !=null && identity.provider === 'GootWork'" style="color:#fff; font-size:14px" id="description">
                            Email: {{userstorage.email}}
                        </p>
                        <p style="color:#fff; font-size:14px" id="description">
                            {{userstorage.phone === '' || userstorage.phone === null ? 'Escriba su N° celular' : 'N° celular: ' +userstorage.phone}}
                        </p>
                        <p style="color:#fff; font-size:14px" id="description">
                            {{userstorage.address === '' ? 'Escriba su direcciòn' : 'Dirección: ' + userstorage.address}}
                        </p>
                        <div id="actions">
                            <button @click="opendialog2"><i class="fa fa-user-edit"></i> Editar</button>
                            <button @click="closedialog"><i class="fa fa-times"></i> Salir</button>
                        </div>
                    </div>
                </v-flex>
            </v-dialog>
        </v-layout> 

        <!-- EDITAR-->
               
               <v-layout>
                 <v-dialog v-model="dialog2" style="z-index:1000" max-width="550"> 
                    <div class="modal-content">
                        <form @submit.prevent="editdatauser">
                        <div class="modal-header" >
                            <h5  class=" tamañoTitulo modal-title" id="exampleModalCenterTitle" >Cambiar Perfil Usuario</h5>
                            <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click="dialog2=false">
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <div class="modal-body" style="margin-top:40px">                    
                                <div class="form-row">
                                    
                                    <div class="form-group col-md-5" style="text-align: center;">
                                        <!-- ../client/dist/img/logo/o2logo.png -->
                                        <img style="cursor:pointer" @click="upload()" class="perfil" id="avatar" :src="imageUrl" data-toggle="tooltip" title="Hague click para subir su foto">
                                        <v-layout>
                                            <div class="JImg-opciones JImg-opciones--close" v-if="imageFile!=''" @click="removeImage">
                                                <a  href="javascript:void(0)"><i class="fas fa-times"></i></a>
                                            </div>
                                            <div class="JImg-opciones JImg-opciones--close" v-if="imageFile!=''" @click="saveimage">
                                                <a  href="javascript:void(0)"><i class="fas fa-check"></i></a>
                                            </div>
                                        </v-layout>
                                        <input
                                                type="file"
                                                style="display: none"
                                                ref="image"
                                                accept="image/*"
                                                @change="onFilePicked"
                                        > 
                                    </div>
                                    <div class="col-md-7" >                                
                                        <div class="form-group">
                                            <div class="form-row" >   
                                                <i data-toggle="tooltip" :title="!usernameedit ? 'Hague click para editar':'Hague click para no editar'" @click="usernameeditfunction" style="color:#0d6193; margin: auto;" class="col-1 StUnico1 far fa-user"></i>                                         
                                                <input :disabled="!usernameedit" id="userregedit" @keypress="writeusername" @focus="writefullname(), writeemail(), writeaddress(), writeusername(), writephone()" v-model="users.username" type="text" class="col-11 form-control" placeholder="Nombre de Usuario">  
                                                <v-layout v-if="userNameExist" style="margin-top:10px">
                                                        <label class ="fas fa-exclamation-triangle"> El nombre de usuario no esta disponible</label>
                                                </v-layout>                                      
                                            </div>
                                        </div>
                                        <div v-if="identity !=null && identity.provider === 'GootWork'" class="form-group">
                                            <div class="form-row" >                                            
                                                <i data-toggle="tooltip" :title="!emailedit ? 'Hague click para editar':'Hague click para no editar'" @click="emaileditfunction" style="color:#0d6193; margin: auto; cursor:pointer" class="col-1 StUnico1 far fa-envelope"></i>
                                                <input :disabled="!emailedit" type="email" id="emailedit" required @keypress="writeemail" @focus="writefullname(), writeemail(), writeaddress(), writeusername(), writephone()" v-model="users.email"  class="col-11 form-control" placeholder="e-mail">
                                                <v-layout v-if="emailExist" style="margin-top:10px">
                                                        <label class ="fas fa-exclamation-triangle"> Existe un Usuario con este email</label>
                                                </v-layout>   
                                            </div>
                                        </div>
                                        <div class="form-group">
                                            <div class="form-row">                                        
                                                <span @click="passwordeditfunction" :title="!passwordedit ? 'Hague click para editar':'Hague click para no editar'" class="active col-1" style="margin: auto; display: block; cursor:pointer"><i style="color:#0d6193" class="fas fa-lock"></i></span>
                                                <span class="inactive col-1 " style="margin: auto; display: none;"><i style="color:#0d6193" class="fas fa-unlock"></i></span>
                                                <input @keyup="equalpasswordfunction" required :type="typepassword[0].type" v-model="users.password" :disabled="!passwordedit"  class="col-10 form-control" id="inputPassword4" placeholder="password">
                                                <div  style="margin-left:3px" v-if="passwordedit">
                                                    <i @click="showpassword(0)" style="color:#0d6193" :class="typepassword[0].icon"></i>
                                                </div>
                                                
                                            </div>
                                            <div v-if="passwordedit" style="margin-top:10px" class="form-row"> 
                                                <span class="active col-1 " style="margin: auto; display: block;"><i style="color:#0d6193" class="fas fa-lock"></i></span>                                    
                                                <input @keyup="equalpasswordfunction" required :type="typepassword[1].type" v-model="passwordequaldata" class="col-10 form-control" id="inputPassword4" placeholder="Confirmar password">
                                                <div style="margin-left:3px">
                                                    <i @click="showpassword(1)" style="color:#0d6193" :class="typepassword[1].icon"></i>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>   
                                <div class="form-group">
                                    <div class="form-row">
                                        <i style="color:#0d6193; margin: auto;" class="col-1 StUnico2 far fa-user"></i>
                                        <input @keypress="writefullname"  @focus="writefullname(), writeemail(), writeaddress(), writeusername(), writephone()" v-model="users.fullname" type="text" class="col-11 form-control" placeholder="Nombres y Apellidos">
                                    </div>
                                </div> 
                                <div class="form-group">
                                    <div class="form-row">
                                        <i style="color:#0d6193; margin: auto;" class="col-1 StUnico2 far fa-compass"></i>
                                        <input type="text" @keypress="writeaddress" @focus="writefullname(), writeemail(), writeaddress(), writeusername(), writephone()" v-model="users.address"   class="col-11 form-control" placeholder="Dirección">
                                    </div>
                                </div>
                                <div class="form-row">                            
                                    <i style="color:#0d6193; margin: auto;" class="col-1 StUnico2 fas fa-mobile-alt"></i>                        
                                    <input type="number" @keypress="writephone" @focus="writefullname(), writeemail(), writeaddress(), writeusername(), writephone()" v-model="users.phone" class="col-11 col-md-5 form-control" placeholder="Celular">
                                    <i style="color:#0d6193; margin: auto;" class=" col-1 StUnico2 fas fa-venus-mars"></i>
                                    <select v-model="users.gender" class="MargSexo col-11 col-md-5 form-control">
                                        <option selected>--Elija--</option>
                                        <option value="F">Mujer</option>
                                        <option value="M">Varon</option>
                                    </select>
                                </div>                                 
                            
                        </div>
                        <div class="modal-footer">
                            <button type="button" style="vertical-align:0 ;border:0 ; background: rgb(172, 175, 175);" class="btn btn-secondary" @click="dialog2=false">Cancelar</button>
                            <button type="submit" :disabled="passwordedit && !passwordequal" style="vertical-align:0 ;border:0 ; background: linear-gradient(to bottom, #1b7aaf, #1f8aac, #0d6193);" class="btn btn-primary">Guardar Cambios</button>
                        </div>
                    </form>
                </div>
                </v-dialog>
            </v-layout> 
        
    </div>
</template>
<script>
// Import the EventBus we just created.
import { EventBus } from '../../../helpers/eventbus/event-bus.js'
import {RoutesStorage} from '@/helpers/storage'
import initVue from '../../../helpers/initVue'
import users from '../../../models/user'

import {
    mapGetters
} from 'vuex'

export default {
    data(){
        return{
            emailedit: false,
            usernameedit: false,
            userNameExist: false,
            emailExist: false,
            typepassword:[
                {
                    type:'password',
                    icon:'fas fa-eye'
                },
                {
                    type:'password',
                    icon:'fas fa-eye'
                },

            ],
            successedit: false,
            messageedit: '',
            valid:true,
            identity: null,
            token: null,
            dialog: false,
            dialog2:false,
            show1: false,
            show2: false,
            users: new users(),
            userstorage: {},
            imageName: '',
            session: false,
            passwordedit: false,
            passwordequal:false,
            passwordequaldata:'',
            imageUrl: '',
            imageFile: '',
            equaldatauseridentity: false,
            iconloadingforeditdata:false,
            rules: {
                required: value => !!value || 'requerido.',
                min: v => v.length >= 8 || 'Mínimo 8 caracteres',
                emailMatch: () => ('The email and password you entered don\'t match'),
                    
                passwordvalidate: value => {
                    const pattern = /^(?=.*\d)(?=.*[a-záéíóúüñ]).*[A-ZÁÉÍÓÚÜÑ]/
                    return pattern.test(value) || 'Tu contraseña debe tener un carácter, una letra mayúscula, una minúscula y un número'
                },
                passwordspace: value =>{
                    const pattern = /\s/
                    return !pattern.test(value) || 'No dejes espacios en blanco'
                },
                emailvalidate: value =>{
                    const pattern = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/
                    return pattern.test(value) || 'El email debe contener @ y otros carácteres mas'
                },
                passwordequal: value =>{
                    let passwordcondition = this.users.password !== value
                    return !passwordcondition || 'La contraseña no concuerda con lo anterior escrito'
                },
            }
        }
    },

    computed: mapGetters({
        indetityU: 'getIdentity',
        tokenU: 'getToken'
    }),
    
    mounted(){
        this.getidentity()
        this.getuser()

        EventBus.$on('opendialog', () =>{
            this.opendialog()
        })

        EventBus.$on('getuser', () =>{
            this.getuser()
        })
    },

    methods:{
        equalpasswordfunction(){
            let passwordisequal = this.users.password === this.passwordequaldata
            //console.log(this.users.password.length)
            if(this.users.password.length >= 8){
                if(this.users.password !== '' || this.passwordequaldata !==''){
                    if(passwordisequal){
                        this.passwordequal = true
                    }else{
                        this.passwordequal = false
                    }
                }else{
                    this.passwordequal = false
                }
            }else{
                this.passwordequal = false
            }
            
            
        },

        showpassword(index){
            if(this.typepassword[index].type === 'password'){
                this.typepassword[index].type='text'
                this.typepassword[index].icon='fas fa-eye-slash'
            }else{
                this.typepassword[index].type='password'
                this.typepassword[index].icon='fas fa-eye'
            }
        },

        passwordeditfunction(){
            if(this.passwordedit){
                this.passwordedit = false
            }else{
                this.passwordedit = true
            }
        },

        emaileditfunction(){
            if(this.emailedit){
                this.emailedit = false
            }else{
                this.emailedit = true
            }
        },

        usernameeditfunction(){
            if(this.usernameedit){
                this.usernameedit = false
            }else{
                this.usernameedit = true
            }
        },

        saveimage(){
            this.imageFile = ''
        },

        upload:function(){
            this.pickFile();
        },
        pickFile () {
            this.$refs.image.click()
        },

        removeImage:function(){
            this.imageUrl = ''
            this.imageFile = '';
            this.getuser()
        },

        getuser(){
            if(this.session){
                this.axios.get(`users/getuser`)
                .then((res) => {
                    this.userstorage = res.data.user
                    this.imageUrl = this.userstorage.photo
                    this.users.imageFile = this.imageUrl
                    this.users.fullname = this.userstorage.fullname
                    this.users.email = this.userstorage.email
                    this.users.username = this.userstorage.username
                    this.users.phone = this.userstorage.phone
                    this.users.gender = this.userstorage.gender
                    this.users.address = this.userstorage.address
                    if(this.users.username === this.userstorage.username){
                        this.equaldatauseridentity = true
                    }
                    if(this.successedit === true){
                        window.location = window.location.href
                        this.iconloadingforeditdata = false
                    }
                })
                .catch((err) => {
                    console.log(err)
                })
            }
        },

        writefullname(){
            let emptyfullname = this.users.fullname === '' || this.users.fullname === null
            if(emptyfullname){
                this.users.fullname = this.userstorage.fullname
            }

        },

        writeemail(){
            let emptyemail = this.users.email === '' || this.users.email === null
            if(emptyemail){
                this.users.email = this.userstorage.email
            }
                
        },

        writeaddress(){
            let emptyaddress = this.users.address === '' || this.users.address === null
            if(emptyaddress){
                this.users.address = this.userstorage.address
            }
        },

        writeusername(){
            let emptyusername = this.users.username === '' || this.users.username === null
            if(emptyusername){
                this.users.username = this.userstorage.username
            }
        },

        writephone(){
            let emptyphone = this.users.phone === '' || this.users.phone === null
            if(emptyphone){
                this.users.phone = this.userstorage.phone
            }
        },
        /*******************************************************
 * * Obteniendo la identidad para validar el token
 *******************************************************/
        getidentity(){
            this.identity = initVue.getIdentity().identity
            this.token = initVue.getIdentity().token
            this.session = initVue.isLogged(this.identity, this.token)
            //console.log(this.session)
    
        },

        opendialog(){
          this.dialog=true
        },
        opendialog2(){
          this.dialog=false
          this.dialog2=true
        },

        pickFile () {
            this.$refs.image.click()
        },
        onFilePicked (e) {
			const files = e.target.files
			if(files[0] !== undefined) {
				this.imageName = files[0].name
				if(this.imageName.lastIndexOf('.') <= 0) {
					return
                }
                
                if (!(/\.(jpg|png|gif|jpeg)$/i).test(this.imageName))
                {
                    alert('Comprueba la extensión de tus imagenes, recuerda que los formatos aceptados son .gif, .jpeg, .jpg y .png');
                    this.imageName = ''
                    this.imageUrl = '/'+this.userstorage.photo
                }else{
                    const fr = new FileReader ()
                    fr.readAsDataURL(files[0])
                    fr.addEventListener('load', () => {
                        this.imageUrl = fr.result
                        this.imageFile = files[0] // this is an image file that can be sent to server...
                        this.imageName = files[0].name
                        //console.log(this.imageUrl)

                        
                    })
                }
			} else {
				this.imageName = ''
				this.imageFile = ''
				this.imageUrl = '/'+this.userstorage.photo
			}
        },

         closedialog2(){
            this.dialog2 = false
        },

        closedialog(){
            this.dialog = false
        },

        /*******************************************************
 * * Cerrar Sesión
 *******************************************************/
        logout(){
          this.userstorage = {}
          this.identity = null
          this.token = null
          localStorage.removeItem('iden')
          localStorage.removeItem('tok')
          localStorage.clear
          this.$store.dispatch('saveIdentity', null)
          this.$store.dispatch('saveToken', null)
          window.location = '/'
        },

        editdatauser(){
                this.users.imageFile = this.imageUrl
                this.iconloadingforeditdata = true
                this.writefullname()
                this.writeaddress()
                this.writeusername()

                this.axios.put(`users/edituser/${this.identity._id}/${this.emailedit}/${this.usernameedit}/${this.passwordedit}/${this.token}`, this.users)
                .then(() =>{
                    this.getuser()
                    EventBus.$emit('getuser')
                    //console.log(res)
                    this.successedit= true
                    if(this.passwordedit === true){
                        this.messageedit = 'Datos Editados'
                        this.logout()
                    }else{
                        this.messageedit = 'Datos Editados'
                    }
                    setTimeout(() => {
                        this.successedit = false
                    }, 5000)
                    this.iconloadingforeditdata = false
                    localStorage.removeItem('user')

                })

                .catch((err) =>{
                    let msg = err.response.data.message

                    if (msg === "El email ya existe") {
                        this.emailExist = true
                        document.getElementById('emailedit').focus()
                        setTimeout(() => {
                            this.emailExist = false
                        }, 5000)
                    }else if (msg === "El nombre de usuario ya existe") {
                        this.userNameExist = true
                        document.getElementById('userregedit').focus()
                        setTimeout(() => {
                            this.userNameExist = false
                        }, 5000)
                    }else {
                        console.log(err)
                    }
                    this.getuser()
                    this.iconloadingforeditdata = false
                    //EventBus.$emit('getuser')
                    
                })
            
        }
    }
}
</script>
<style lang="scss" scoped>
    /* foto */
        .perfil{
            max-width: 140px;
            min-height: 140px;
            border-radius: 50%;            
        } 
        .tamañoTitulo{
            font-size: 30px;
            font:bold;
            font-family: sans-serif;
        }

        .form-control{
            border:0px;
            border-bottom: 2px solid #ced4da;
            border-radius: 0;
        }
        .espacio{
            padding:20px;
        }

        @media (max-width:768px){            
            .MargSexo{
                margin-top: 20px;
            }
        }
        @media (min-width:768px){
            i.col-1.StUnico1{
                padding-left: 0;
            }
            i.col-1.StUnico2{
                padding-left: 15px;
            }
            span.active.col-1{
                padding-left: 0;                
            }
            span.inactive.col-1{
                padding-left: 0;                
            }
            form.espacio1{
                padding: 10px 30px 10px 10px;
            }
        }
        @media (max-width:578px){
            .tamañoTitulo{
                font-size: 25px;
            }
        }
</style>
